// src/hooks/useAuth.ts
import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";

import { apiClient } from "@/lib/api-client";

export interface User {
  id: string;
  name: string;
  username: string;
  role: string;
  master_fakultas_id: string;
  niu?: string;
}

const fetchUser = async (): Promise<User | null> => {
  // 1. Ambil token dari cookie
  const token = Cookies.get("auth_token");

  // 2. Jika tidak ada token, langsung hentikan proses dan kembalikan null
  if (!token) {
    console.log("Token tidak ditemukan, membatalkan fetch user.");
    return null;
  }

  try {
    let data;
    let role = "";

    try {
      // 3a. Coba ambil profile sebagai Admin
      data = await apiClient<any>("/api/v1/admin/profile");
      role = data.jenis;
    } catch (adminError) {
      // 3b. Jika gagal (misalnya karena bukan admin), coba ambil profile sebagai Dosen
      data = await apiClient<any>("/api/v1/dosen/profile");
      role = "dosen"; // ROLES.DOSEN
    }

    return {
      id: String(data.id || data.dosen_id),
      name: data.nama_lengkap || data.nama || data.name,
      username: data.username || data.email_sso || data.email || data.name,
      role: role,
      master_fakultas_id: data.master_fakultas_id || "",
      niu: data.no_induk_undiksha,
    };
  } catch (error) {
    console.error("Failed to fetch user profile", error);
    return null;
  }
};

export function useAuth() {
  // Cek keberadaan token untuk memberitahu React Query
  const hasToken = !!Cookies.get("auth_token");

  const {
    data: user,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["user"],
    queryFn: fetchUser,

    // BEST PRACTICE REACT QUERY:
    // Jangan jalankan query API sama sekali jika hasToken bernilai false
    enabled: hasToken,

    // staleTime: 1000 * 60 * 5,
    // retry: false,
  });

  return {
    user,
    // Jika data user ada (tidak undefined/null), berarti terautentikasi
    isAuthenticated: !!user,

    // Modifikasi sedikit isLoading:
    // Jika token dari awal sudah tidak ada, kita tidak perlu menganggapnya "sedang loading".
    // Ia langsung berstatus false agar bisa langsung di-redirect ke SSO.
    isLoading: hasToken ? isLoading : false,

    isError,
  };
}
